<template>
  <div class="body">
    <div class="title">
      体彩金刚区设置
      <!-- 面包屑导航区域 -->
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/lotteryTicket' }"
            ><span class="dsadf"> 配置中心 </span></el-breadcrumb-item
          >
          <el-breadcrumb-item>体彩金刚区配置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="btnsearch">
      <div class="left" style="margin-bottom: 24px">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="medium"
          @click="handleRouteGoAdd"
          >添加</el-button
        >
      </div>
      <!-- <div class="right">
        <el-form :inline="true">
          <el-form-item>
            <el-select
              placeholder="跳转类型"
              v-model="query.url_type"
              @change="Discountsearch"
              style="min-width: 168px; width: 168px"
              clearable
            >
              <el-option
                v-for="item in optionUrltype"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              placeholder="启用状态"
              v-model="query.status"
              @change="Discountsearch"
              style="min-width: 168px; width: 168px"
              clearable
            >
              <el-option
                v-for="item in optionStatus"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div> -->
    </div>
    <vxe-table
      :data="bannerList"
      border
      stripe
      resizable
      highlight-cell
      highlight-hover-row
      max-height="750"
      class="mytable-scrollbar"
      show-overflow
      keep-source
      align="center"
      highlight-current-column="true"
    >
      <vxe-table-column field="id" title="导航 ID" min-width="100">
      </vxe-table-column>
      <vxe-table-column field="content" title="图片" min-width="170">
        <template slot-scope="scope">
          <img :src="scope.row.pic" alt="" class="imgs" />
        </template>
      </vxe-table-column>
      <vxe-table-column field="name" title="标题" min-width="100">
      </vxe-table-column>
      <vxe-table-column title="跳转类型" min-width="100">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.url_type == 1"
            >内部链接</el-tag
          >
          <el-tag type="warning" v-else-if="scope.row.url_type == 3"
            >外部链接</el-tag
          >
        </template>
      </vxe-table-column>
      <vxe-table-column field="url" title="跳转链接" min-width="100">
      </vxe-table-column>
      <vxe-table-column field="sort" title="生效时间" min-width="280">
        <template slot-scope="scope">{{
          scope.row.s_date + "至" + scope.row.e_date
        }}</template>
      </vxe-table-column>
      <vxe-table-column field="sort" title="排序" min-width="50">
      </vxe-table-column>
      <vxe-table-column title="状态 " min-width="80">
        <template slot-scope="scope">
          <vxe-switch
            v-model="scope.row.status"
            @change="(ev) => onStatusChange(ev, scope.row)"
          ></vxe-switch>
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" min-width="200">
        <template slot-scope="scope">
          <!-- 修改按钮 -->
          <el-button
            type="primary"
            size="mini"
            @click="hanldeRouteGoEdit(scope.row)"
            icon="el-icon-edit"
            >修改</el-button
          >
          <!--      删除     -->
          <el-button
            type="danger"
            size="mini"
            @click="onBannerDelete(scope.row)"
            icon="el-icon-delete"
            >删除</el-button
          >
        </template>
      </vxe-table-column>
    </vxe-table>
    <div v-if="pageshow">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="cur_page"
        :page-sizes="[10]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  getBannerListWithLotteryTicket,
  editBannerStatusWithLotteryTicket,
  deleteBannerWithLotteryTicket,
} from "@/api/configuration-center";

export default {
  name: "index",
  data() {
    return {
      pageshow: true,
      total: null,
      query: {
        token: sessionStorage.getItem("token"),
        url_type: null,
        page: 1,
        pagesize: 10,
      },
      bannerList: [],
      token: sessionStorage.getItem("token"),
      optionsort: [
        {
          value: "0",
          label: "顺序排序",
        },
        {
          value: "1",
          label: "上传时间顺序",
        },
        {
          value: "2",
          label: "上传时间倒序",
        },
        {
          value: "3",
          label: "启用优先",
        },
      ],
      optiontype: [
        {
          value: "0",
          label: "体彩顶部",
        },
        {
          value: "1",
          label: "体彩广告位",
        },
        {
          value: "2",
          label: "我的顶部",
        },
      ],
      optionUrltype: [
        {
          value: "1",
          label: "内部链接",
        },
        {
          value: "2",
          label: "外部链接",
        },
      ],
      optionStatus: [
        {
          value: -1,
          label: "全部",
        },
        {
          value: 1,
          label: "启用",
        },
        {
          value: 2,
          label: "禁用",
        },
      ],
      cur_page: 1,
    };
  },
  created() {
    this.getLotteryTicketList();
  },
  methods: {
    onStatusChange(ev, row) {
      console.log(ev, row);
      const statusObj = {
        token: sessionStorage.getItem("token"),
        id: row.id,
        status: ev.value ? 1 : 2,
      };

      editBannerStatusWithLotteryTicket(statusObj).then(({ data: res }) => {
        if (res.result === -1) {
          this.$message({
            message: res.msg,
            type: "error",
            duration: "2000",
          });
          setTimeout(() => {
            window.sessionStorage.clear();
            this.$router.push("/login");
          }, 1000);
        }
        if (res.result === 0) {
          this.$message({
            message: res.msg,
            type: "error",
            duration: "2000",
          });
          return false;
        }
        if (res.result === 1) {
          this.$message({
            message: res.msg,
            type: "success",
            duration: "2000",
          });
          this.getLotteryTicketList();
        }
      });
    },

    handleSizeChange(val) {
      this.query.pagesize = val;
      this.handleCurrentChange(this.query.page);
    },
    handleCurrentChange(val) {
      this.query.page = val;
      const obj = {};
      obj.pagesize = this.query.pagesize;
      obj.page = this.query.page;
      obj.url_type = this.query.url_type;
      obj.is_status = this.query.is_status;
      getBannerListWithLotteryTicket(obj).then(({ data: res }) => {
        this.bannerList = res.list || [];
      });
    },
    onBannerDelete(item) {
      this.$confirm("确认删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          const obj = {
            token: sessionStorage.getItem("token"),
            id: item.id,
          };
          deleteBannerWithLotteryTicket(obj).then(({ data: res }) => {
            this.getLotteryTicketList(this.query);
          });
        })
        .catch(() => {});
    },
    Discountsearch() {
      this.cur_page = 1;
      this.getLotteryTicketList();
      this.pageshow = false; // 让分页隐藏
      this.$nextTick(() => {
        // 重新渲染分页
        this.pageshow = true;
      });
    },
    getLotteryTicketList() {
      getBannerListWithLotteryTicket(this.query).then(({ data: res }) => {
        console.log("res", res);
        this.bannerList = res.data.list;
        this.total = res.total;
        this.bannerList.forEach((i) => {
          if (i.status === 1) {
            i.status = true;
          } else {
            i.status = false;
          }
        });
      });
    },
    hanldeRouteGoEdit(item) {
      this.$router.push(`/lotteryTicketEdit?id=${item.id}`);
    },
    handleRouteGoAdd() {
      this.$router.push("/lotteryTicketEdit");
    },
  },
};
</script>

<style scoped lang="less">
.imgs {
  width: 130px;
  height: 70px;
  opacity: 1;
  background: rgba(0, 0, 0, 0);
  border-radius: 2px;
}
.body {
  display: flex;
  flex-direction: column;
  .title {
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    margin-bottom: 35px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .fansk {
      margin-top: 30px;
      margin-left: 32px;
    }
    .dsadf {
      color: #3d9aff;
    }
  }
  .btnsearch {
    display: flex;
    flex-direction: row;
    align-items: center;
    .left {
      margin-right: 150px;
    }
    .right {
      margin-top: 27px;
    }
  }
}
</style>
